// components/utils/MandantErstellen.jsx

import React, { useState } from "react";
import { useNavigate } from "react-router";
import MandantErstellenForm from "./MandantErstellenForm";
import {useAuth} from "../context/AuthContext";

const MandantErstellen = () => {
  const navigate = useNavigate();
  const { fetchWithAuth } = useAuth();

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    vorname: "",
    name: "",
    mandant_name: ""
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setError("");

    try {
      const response = await fetchWithAuth(`/api/admin/create-mandant/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("Account erfolgreich erstellt!");
      } else {
        setError(data.error || "Fehler bei der Erstellung.");
      }
    } catch (err) {
      setError("Netzwerkfehler: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MandantErstellenForm
      formData={formData}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      loading={loading}
      message={message}
      error={error}
      navigate={navigate}
    />
  );
};

export default MandantErstellen;